import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSmtpCredentials } from '../../helpers/api_helper';

const useObtenerSmtpCredentials = (refresh = 0) => {
    const [smtpCredentials, setSmtpCredentials] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchSmtpCredentials = async () => {
            if (!tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getSmtpCredentials({
                    tenantId, empresa
                });
                setSmtpCredentials(response);
            } catch (err) {
                const errorMessage = `Failed to fetch SMTP credentials: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setSmtpCredentials(null);
            } finally {
                setLoading(false);
            }
        };

        fetchSmtpCredentials();
    }, [tenantId, empresa, refresh]);

    return { smtpCredentials, loading, error };
};

export default useObtenerSmtpCredentials;